import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

@Injectable()
export class DictionaryService {

  constructor(private _http: HttpClient) {
  }

  getAllCenterProfessionList() {
    return this._http.get<any[]>('api/a/dictionary/profession/all');
  }

  getAllUniversitiesProfessionList() {
    return this._http.get<any[]>('api/a/dictionary/profession/univer/all');
  }

  getGsLegalEntityProfessions(collegeId, applicationId, applicationPlaceCountId) {
    return this._http.get<any[]>('api/a/dictionary/profession/gs/legal-entities/' + collegeId
      + '/' + applicationId + '/' + applicationPlaceCountId);
  }

  getGsProfessionPlaceCountList(page) {
    return this._http.post<any>('api/a/gs/profession/place/count', page);
  }

  saveGsSpecializationPlaceCount(placeCount) {
    return this._http.post<any>('api/a/gs/profession/place/count/specialization', placeCount);
  }

  getCitizenshipList() {
    return this._http.get<any[]>('api/a/dict/CenterCountry');
  }

  getScientificDegreeList() {
    return this._http.get<any[]>('api/a/dict/ScientificDegree');
  }

  getAcademicStatusList() {
    return this._http.get<any[]>('api/a/dict/AcademicStatus');
  }

  getScienceFieldList() {
    return this._http.get<any[]>('api/a/dict/ScienceField');
  }

  getAcademicDegreeList() {
    return this._http.get<any>('api/s/colleges/getDegreeTypes');
  }

  getICTypeList() {
    return this._http.get<any>('api/a/dict/ICType');
  }

  getDicTables() {
    return this._http.get<any>('api/a/dict/DicTables');
  }

  getIcDepartmentList() {
    return this._http.get<any>('api/a/dict/IcDepartment');
  }

  getSexList() {
    return this._http.get<any>('api/a/dict/Sex');
  }

  getPaymentFormList() {
    return this._http.get<any>('api/a/dict/PaymentForm');
  }

  getGrantTypeList() {
    return this._http.get<any>('api/a/dict/GrantType');
  }

  getHasJobList() {
    return this._http.get<any>('api/a/dict/HasJob');
  }

  getJobPlaceType() {
    return this._http.get<any>('api/a/dict/JobPlaceType');
  }

  getDicRegisteredInLawEnforcementList() {
    return this._http.get<any>('api/a/dict/DicRegisteredInLawEnforcement');
  }

  getDicEducatedList() {
    return this._http.get<any>('api/a/dict/DicEducated');
  }

  getDicBaseEducationList() {
    return this._http.get<any>('api/a/dict/DicBaseEducation');
  }

  getDicClassifierTypesList() {
    return this._http.get<any>('api/a/dict/DicClassifierType');
  }

  getDicTemplateTypeList() {
    return this._http.get<any>('api/a/dict/DicTemplateType');
  }


  /**  Параметры направлений специальностей */

  getDicDirectionOfSpecialtyList() {
    return this._http.get<any>('api/a/dict/direction/of/speciality/all/list');
  }

  saveDicDirectionOfSpecialty(dto) {
    return this._http.post<any>('api/a/dict/direction/of/speciality', dto);
  }

  deleteDicDirectionOfSpecialty(id) {
    return this._http.delete<any>('api/a/dict/direction/of/speciality/' + id);
  }

  /** Тип предмета */
  getDicAdmissionSubjectTypeList() {
    return this._http.get<any[]>('api/a/dict/DicAdmissionSubjectType');
  }


  /** Предметы для поступления */
  getDicSubjectForAdmissionList(params) {
    return this._http.post<any>('api/a/dict/admission/subject/all/list', params);
  }

  /** Предметы для поступления по типу, год*/
  getDicSubjectForAdmissionListByTypeAndYear(subjectTypeId, year) {
    return this._http.get<any>(`api/a/dict/admission/subject/by/type/${subjectTypeId}/${year}/list`);
  }

  /** Профильные предметы для поступления по спец, типу, год*/
  getAdmissionSubjectListByProfessionAndTypeAndYear(subjectTypeId, year, centerProfessionId: number) {
    return this._http.get<any>(`api/a/dict/admission/subject/by/profession//${subjectTypeId}/${year}/${centerProfessionId}`);
  }

  saveDicSubjectForAdmission(dto) {
    return this._http.post<any>('api/a/dict/admission/subject', dto);
  }

  deleteDicSubjectForAdmission(id) {
    return this._http.delete<any>('api/a/dict/admission/subject/' + id);
  }

  /** Профильные предметы по специальности для поступления в учреждение ТиПО */
  getDicAdmissionList() {
    return this._http.get<any[]>('api/a/dict/admission/all/list');
  }

  getDicAdmissionTableList(page) {
    return this._http.post<any>('api/a/dict/admission/all/list', page);
  }

  saveDicAdmission(dto) {
    return this._http.post<any>('api/a/dict/admission', dto);
  }

  deleteDicAdmission(id) {
    return this._http.delete<any>('api/a/dict/admission/' + id);
  }

  getAcademicDegreeById(id) {
    return this._http.get<any>('api/s/colleges/getDegreeTypes/' + id);
  }

  getUniversitiesList() {
    return this._http.get<any>('api/a/dict/Universities');
  }

  // platonus local dicts
  getUniversityNationalityDictList(universityId) {
    return this.getUniversityLocalDictList(universityId, 'Nationality');
  }

  getUniversityProfessionDictList(universityId) {
    return this.getUniversityLocalDictList(universityId, 'Profession');
  }

  getUniversityEmploymentReasonDictList(universityId) {
    return this.getUniversityLocalDictList(universityId, 'DicEmploymentReason');
  }

  private getUniversityLocalDictList(universityId, clazz) {
    return this._http.get<any>(`api/dic/common/by/college/${clazz}/${universityId}`);
  }

  getInstitutionByRegionCode(regionCode) {
    return this._http.get<any>(`api/dictionary/institutions/get/${regionCode}`);
  }

  getStudyFormsList(universityId) {
    return this.getUniversityLocalDictList(universityId, 'StudyForm');
  }

  getCenterStudyLanguagesList() {
    return this._http.get<any>('api/a/dict/CenterStudyLanguages');
  }

  getCenterAdmissionQuotasList() {
    return this._http.get<any>('api/a/dict/CenterAdmissionQuotas');
  }

  getBenefitsList() {
    return this._http.get<any>('api/a/dict/Benefits');
  }

  getQuotasDictList(filter) {
    return this._http.post<any>('api/dictionary/centerAdmissionQuotas/getAll', filter);
  }

  getDicTablesByIdList(id) {
    if (id) {
      return this._http.get<any>(`api/a/dict/DicTables/table_id/${id}`);
    }
  }

  getMilitaryOfficeResidenceList() {
    return this._http.get<any>('api/a/dict/MilitaryOfficeResidence');
  }

  /** Электронная медицинская карточка обучающегося*/
  getMedicalRecordCategoryList() {
    return this._http.get<any>('api/a/dict/MedicalRecordCategory');
  }

  /** Категория проподователя */
  getTutorCategoryList() {
    return this._http.get<any>('api/a/dict/TutorCategory');
  }

  getCenterProfessionsByClassifier(classifierType: number) {
    return this._http.get<any[]>(`api/a/dictionary/profession/list/by/classifierType/${classifierType}`);
  }

  getDepartmentsDictList() {
    return this.getUniversityLocalDictList(0, 'Department');
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/shared/services/dictionary.service.ts